const inputSizeMap = {
  xs: {
    inputClass: 'input-xs',
    iconClass: 'icon-xs',
    iconSize: 14,
  },
  sm: {
    inputClass: 'input-sm',
    iconClass: 'icon-sm',
    iconSize: 18,
  },
  md: {
    inputClass: 'input-md',
    iconClass: 'icon-md',
    iconSize: 20,
  },
  lg: {
    inputClass: 'input-lg',
    iconClass: 'icon-lg',
    iconSize: 24,
  },
  xl: {
    inputClass: 'input-xl',
    iconClass: 'icon-xl',
    iconSize: 28,
  },
};

type InputType =
  | 'text'
  | 'email'
  | 'password'
  | 'date'
  | 'number'
  | 'tel'
  | 'url'
  | 'search'
  | 'time'
  | 'datetime-local'
  | 'month'
  | 'week'
  | 'color'
  | 'file'
  | 'select'
  | 'textarea'
  | 'radio';

interface IconProps {
  name: string;
  size?: number;
  color: string;
}

export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export { inputSizeMap, type InputType, type IconProps };
